module.exports = "https://p.cds.unp.clasificados.pe/logo-trome-grey.bec1c593913375d8780cc63f9b450fd8.svg";